import { ModelBase } from "@singularsystems/neo-core"

export default class ReportingReportFilter extends ModelBase {

  reportingReportId: number | null = 0;

  reportingReportName: string = "";
}